// Urgently document types configuration
// This can be easily maintained and updated without hardcoding in components
export const URGENTLY_DOCUMENT_TYPES = [
  { id: 'other', name: 'Other' },
  { id: 'customer_signature', name: 'Customer Signature' },
  { id: 'customer_vehicle_photo', name: 'Customer Vehicle Photo' },
  { id: 'license_plate_photo', name: 'License Plate Photo' },
  { id: 'receipt', name: 'Receipt' }
];

// Helper function to get display name by id
export const getUrgentlyDocumentTypeName = (id) => {
  const type = URGENTLY_DOCUMENT_TYPES.find(type => type.id === id);
  return type ? type.name : id;
};

// Helper function to get all available types
export const getUrgentlyDocumentTypes = () => URGENTLY_DOCUMENT_TYPES;
